import { useQuery, useQueryClient } from "@tanstack/react-query";
import { EndpointsService } from "../services/endpoints/endpoints.service";
import { Formatter } from "../services/formatter/formatter.service";
import { List } from "../models/misc.model";

export const useCallInfo = (callSid: string) => {
	const queryClient = useQueryClient();
	const queryKey = ["call-info", { callSid }];
	const query = useQuery({
		queryKey: queryKey,

		queryFn: async () => {
			const response = await EndpointsService.dataRetriever.getCallInfo({
				config: { params: { callSid } },
			});
			if (!response?.length) return [];

			return response.map((pt) => ({
				id: pt.id,
				label: `${Formatter.fullName(pt.firstName, pt.lastName)} / ${pt.kannactId}`,
			})) as List;
		},

		enabled: !!callSid,
		retry: 0,
	});

	return {
		...query,
		invalidate: () =>
			queryClient.invalidateQueries({
				queryKey: queryKey,
			}),
	};
};
